import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '知事と一緒に車座トーク | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="知事と一緒に車座トーク　開催しました" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2022夏号 No.158 目次",
              path: "/no158"
            },
            {
              name: "知事と一緒に車座トーク"
            }
          ]}
        />
        <img
          src={`${basePath}/no158/img/4-10.png`}
          alt="車座トークの様子"
          css={style.img(500)}
        />
        
        <p>4月6日（水）に関川村で、「小さくてもキラリと光る村～住民が主役の元気な地域づくり～」をテーマに、地域の課題に向き合い、活動されている方々と知事が意見交換を行いました。<br />関川村の魅力に自信と誇りを持ち、発信することの大切さや、村ならではの宝物を活用した商品づくり、交流活動など、地域の元気づくりに向けて活発に意見交換を行いました。</p>
        
        <BackBtn href={"/no158"} />
      </Content>
    </Page>
  )
}
export default Home
